<template>
  <div class="mx-auto px-4 bg-white min-h-full">
    <div class="px-4 py-20">
      <Sidebar></Sidebar>
      <Header> {{$t('all.new_message')}}
        <communication-header>
          <div slot="left">
            <div class="flex flex-1">
              <i
                class="fas text-white pt-6px pr-2 fa-times"
                @click="goBack"
              ></i>
            </div>
          </div>
          <div slot="right">
            <div class="p-1 flex">
              <div
                class="flex-wrap mr-3"
                @click="sendNotify"
              >
                <i
                  v-if="!notify"
                  class="fas fa-bell-slash text-white"
                ></i>
                <i
                  v-if="notify"
                  class="fas fa-bell text-white"
                ></i>
              </div>
              <i
                v-if="fieldsEmpty"
                class="fas fa-paper-plane text-white"
              ></i>
              <i
                v-if="!fieldsEmpty"
                @click="sendEmail"
                class="fas fa-paper-plane text-white"
              ></i>
            </div>
          </div>
        </communication-header>
      </Header>
      <div class="pt-8">
        <form class="w-full max-w-sm">
          <div
            v-if="userInfo.role === 'teacher'"
            class="pb-2">
            <ul class="list-reset flex justify-center pb-2">
              <li
                class="mr-1"
                @click="selectAll"
              >
                <div
                  :class="!multiSelect ? 'bg-blue text-white' : ''"
                  class="inline-block font-medium py-1 px-4 hover:bg-blue hover:text-white text-grey"
                >{{$t('all.send_to_all')}}</div>
              </li>
              <li @click="selectSpecific">
                <div
                  :class="multiSelect ? 'bg-blue text-white' : ''"
                  class="inline-block font-medium py-1 px-4 hover:bg-blue hover:text-white text-grey"
                >{{$t('all.send_specific')}}</div>
              </li>
            </ul>
            <multiselect
              v-if="multiSelect"
              v-model="receivers"
              :hideSelected="true"
              selectLabel=""
              :multiple="true"
              :custom-label="nameAndSurname"
              :placeholder="$t('all.select')"
              track-by="id"
              :options="recipients.items">
              <span slot="noResult">{{$t('all.no_result')}}</span>
            </multiselect>
          </div>
          <div class="flex items-center border-b border-b-2 border-grey pb-2">
            <input
              class="appearance-none bg-transparent border-none w-full text-grey-darker focus:outline-none"
              type="text"
              :placeholder="$t('all.subject')"
              v-model="subject"
              aria-label="Full name"
            >
          </div>
          <div class="flex pt-2 h-screen">
            <textarea
              :placeholder="$t('all.write_message')"
              v-model="message"
              class="appearance-none bg-transparent border-none w-full text-grey-darker focus:outline-none">
            </textarea>
          </div>
        </form>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import multiselect from 'vue-multiselect';
import map from 'lodash/map';

export default {
  name: 'CreateCommunication',
  props: ['id'],
  components: {
    multiselect,
  },
  data() {
    return {
      multiSelect: false,
      notify: false,
      receivers: [],
      message: '',
      subject: '',
    };
  },
  computed: {
    ...mapGetters({
      recipients: 'communication/recipients',
      userInfo: 'authentication/userInfo',
    }),
    fieldsEmpty() {
      return this.message === '' || this.subject === '';
    },
  },
  methods: {
    ...mapActions('communication', ['sendCommunication', 'getRecipientsList']),
    ...mapActions('authentication', ['getUserInfo']),
    sendNotify() {
      this.notify = !this.notify;
    },
    selectAll() {
      this.multiSelect = false;
      this.receivers = [];
    },
    selectSpecific() {
      this.multiSelect = true;
    },
    sendEmail() {
      const result = this.receivers.map(minor => minor.id);
      this.sendCommunication({
        role: this.userInfo.role,
        receivers: result || null,
        subject: this.subject,
        message: this.message,
        notify: this.notify,
        route: this.$route,
      }).then(() => this.goBack());
    },
    goBack() {
      this.$router.go(-1);
    },
    nameAndSurname({ name, surname }) {
      return `${name} ${surname}`;
    },
  },
  async created() {
    await this.getUserInfo();
    if (this.userInfo.role === 'teacher') {
      this.getRecipientsList({
        classroom_id: this.id,
      });
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect__tag,
.multiselect__option--highlight,
.multiselect__tag-icon:hover {
  background: #2c82c9;
  color: #fff;
}
</style>
